var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 13H34.5858C35.1142 13 35.5905 12.8737 36 12.6564V37C36 37.5523 35.5523 38 35 38H4C3.44771 38 3 37.5523 3 37L3 3C3 2.44772 3.44772 2 4 2L25.3436 2C25.1263 2.40949 25 2.88577 25 3.41421V9.99999C25 11.6568 26.3431 13 28 13ZM28 11H34.5858C35.4767 11 35.9229 9.92285 35.2929 9.29289L28.7071 2.7071C28.0771 2.07713 27 2.5233 27 3.41421V9.99999C27 10.5523 27.4477 11 28 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon_File.0b102b9c313dcdb3b1f2b6b778199712.svg";
export { ForwardRef as ReactComponent };